<template>
  <div>
    <section
      v-for="(subSection, index) in sectionData.sub_sections"
      :key="index"
      class="pb-0 md:pt-32 last:pb-28"
    >
      <template v-if="subSection.type === 'video'">
        <VideoSection
          :sectionId="sectionData._id"
          :subSectionId="subSection._id"
          :videoData="subSection.data"
          :isEditable="isEditable"
        />
      </template>
      <template v-else-if="subSection.type === 'image'">
        <ImageSection
          :sectionId="sectionData._id"
          :subSectionId="subSection._id"
          :imageData="subSection.data"
          :isEditable="isEditable"
        />
      </template>
      <template v-else-if="subSection.type === 'texts'">
        <TextsSection
          :sectionId="sectionData._id"
          :subSectionId="subSection._id"
          :textData="subSection.data"
          :isEditable="isEditable"
        />
      </template>
      <template v-else-if="subSection.type === 'questions'">
        <QuestionsSection
          ref="questionRef"
          :sectionId="sectionData._id"
          :trainingId="sectionData.training"
          :subSectionId="subSection._id"
          :questionData="subSection.data"
          :isEditable="isEditable"
          @send-answers="setAnswered"
          @send-submit="(val) => this.$emit('sendSubmit', val)"
        />
      </template>
      <template v-else-if="subSection.type === 'pdf'">
        <PDFSection
          :sectionId="sectionData._id"
          :trainingId="sectionData.training"
          :subSectionId="subSection._id"
          :pdfData="subSection.data"
          :sectionTitle="sectionData.title"
          :isEditable="isEditable"
        />
      </template>
    </section>
    <section v-if="acceptOnly">
      <AcceptSection :trainingId="sectionData.training" />
    </section>
  </div>
  <div
    id="popup-modal"
    tabindex="-1"
    aria-hidden="true"
    class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-60 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full"
  >
    <div class="relative p-4 w-full max-w-md max-h-full">
      <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
        <div
          class="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600"
        >
          <h3 class="text-lg font-semibold text-gray-900 dark:text-white">
            Answer all questions
          </h3>
          <button
            @click="toggleEditModal"
            type="button"
            class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white outline-none"
          >
            <svg
              class="w-3 h-3"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 14 14"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
              />
            </svg>
            <span class="sr-only">Close modal</span>
          </button>
        </div>
        <div class="p-4 md:p-5">
          <div class="grid gap-4 mb-4">You have some unanswered questions</div>
          <div class="flex justify-center">
            <button
              @click="togglePopupModal()"
              class="text-white inline-flex items-center bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
            >
              <Icon class="w-4 h-4 ml-0 mr-2" icon="ph:check" />
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VideoSection from "./VideoSection";
import ImageSection from "./ImageSection.vue";
import TextsSection from "./TextsSection.vue";
import QuestionsSection from "./QuestionsSection.vue";
import PDFSection from "./PDFSection.vue";
import AcceptSection from "./AcceptSection.vue";
import { useUserResponse } from "@/store/responses.js";
import { Icon } from "@iconify/vue";

export default {
  emits: ["sendDone", "sendSubmit"],
  props: {
    sectionData: Object,
    isEditable: Boolean,
    acceptOnly: Boolean,
    amountOfQuestions: Number,
  },
  components: {
    VideoSection,
    ImageSection,
    TextsSection,
    QuestionsSection,
    PDFSection,
    AcceptSection,
    Icon,
  },
  data() {
    return {
      answers: [],
      isAnswered: false,
      popup_modal: null,
    };
  },
  mounted() {
    initFlowbite();
    const editModal = document.getElementById("popup-modal");

    const options = {
      placement: "bottom-right",
      backdrop: "dynamic",
      backdropClasses: "bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-50",
      closable: true,
      onHide: () => {},
      onShow: () => {},
      onToggle: () => {},
    };

    const editInstanceOptions = {
      id: "popup-modal",
      override: true,
    };

    this.popup_modal = new Modal(editModal, options, editInstanceOptions);
  },
  computed: {
    collectedResponse() {
      return useUserResponse().userResponse.response;
    },
    // allQuestionsAnswered() {
    //   if (this.isAnswered) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // },
  },
  watch: {
    // allQuestionsAnswered: {
    //   handler: "isDone",
    //   immediate: true,
    // },
    sectionData: {
      immediate: true,
      handler() {
        if (Object.keys(this.sectionData).length !== 0) {
          this.checkIfDone();
        }

        // SAFER: Use trainingId from Pinia
        const store = useUserResponse();
        const currentTrainingId = store.userResponse.trainingId;

        if (
          currentTrainingId &&
          currentTrainingId !== this.sectionData.training
        ) {
          store.userResponse.response = [];
          store.userResponse.trainingId = this.sectionData.training;
        }
      },
    },
  },
  methods: {
    togglePopupModal() {
      this.popup_modal.toggle();
    },
    setAnswered(newData) {
      this.answers.push(newData);
      useUserResponse().userResponse.response = this.answers;
      useUserResponse().userResponse.trainingId = this.sectionData.training;
    },
    isDone(val) {
      this.$emit("sendDone", val);
    },
    checkIfDone() {
      // Collect question IDs
      const questionIds = this.sectionData.sub_sections
        .filter((sub) => sub.type === "questions")
        .flatMap((sub) => sub.data.questions.map((q) => q._id));

      // Collect collected response IDs
      const responseIds = this.collectedResponse.map((cr) => cr.questionId);

      // Ensure all question IDs are in the collected responses
      const allQuestionsAnswered = questionIds.every((id) =>
        responseIds.includes(id)
      );
      this.isAnswered = allQuestionsAnswered;
      this.isDone(this.isAnswered);
    },
    submitAnswers() {
      const questionRef = this.$refs.questionRef;
      const hasUnanswered = questionRef.some((qs) => !qs.isAnswered_v2);

      if (hasUnanswered) {
        this.togglePopupModal();
        // console.log("Please answer all questions before submitting."); //TODO: Add popup
      } else {
        this.isDone(true);
        questionRef.forEach((qs) => {
          qs.submitAnswer_v2();
        });
      }
    },
  },
};
</script>
